import { jsx } from "react/jsx-runtime";
import { useLanguage, useTranslations } from "@vocab/react";
import { useThemeName, Box, Heading } from "braid-design-system";
import { translations } from "../../../../../../ProductSelection/components/elements/Price/MainText/.vocab/index.mjs";
import { isBillableUnitsHighlight, isPriceHidden, isPriceFree, getDisplayPrices, isPriceRounded, formatRoundedPrice, formatExactPrice } from "../../Expectations/RelevantApplications/RelevantApplications.mjs";
import { PriceXL } from "./MainText.css.mjs";
const getMainTextPrice = (price) => {
  if (price.type === "CappedUnitPrice") {
    if (isBillableUnitsHighlight(price.variant)) {
      return price.cappedPrice;
    }
    return price.unitPrice;
  }
  return price;
};
const getMainText = (language, price) => {
  const mainTextPrice = getMainTextPrice(price);
  if (isPriceHidden(mainTextPrice)) {
    return void 0;
  }
  if (isPriceFree(mainTextPrice)) {
    return {
      type: "free",
      text: "Free"
    };
  }
  const prefix = mainTextPrice.isAdditionalPrice ? "+" : "";
  const { displayNetPrice } = getDisplayPrices(mainTextPrice);
  if (isPriceRounded(displayNetPrice.price.value)) {
    const roundedPrice = formatRoundedPrice(
      displayNetPrice.price.value,
      displayNetPrice.price.currency,
      language
    );
    return {
      type: "roundedPrice",
      price: prefix + roundedPrice
    };
  }
  const exactPrice = formatExactPrice(
    displayNetPrice.price.value,
    displayNetPrice.price.currency,
    language
  );
  return {
    type: "exactPrice",
    price: prefix + exactPrice
  };
};
const SIZE = {
  small: "4",
  medium: "3",
  large: "2",
  xlarge: "1"
};
const TextWrapper = ({
  children,
  size
}) => {
  const theme = useThemeName();
  const heading = /* @__PURE__ */ jsx(Heading, { level: SIZE[size], component: "p", weight: "regular", children });
  return size === "xlarge" && theme === "apac" ? /* @__PURE__ */ jsx(Box, { className: PriceXL, children: heading }) : heading;
};
const MainText = ({
  price,
  size
}) => {
  const { language } = useLanguage();
  const { t } = useTranslations(translations);
  const mainText = getMainText(language, price);
  if (!mainText) {
    return null;
  }
  if (mainText.type === "free") {
    return /* @__PURE__ */ jsx(TextWrapper, { size, children: t(mainText.text) });
  }
  if (mainText.type === "roundedPrice" || mainText.type === "exactPrice") {
    return /* @__PURE__ */ jsx(TextWrapper, { size, children: mainText.price });
  }
  return null;
};
export {
  MainText
};
